import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../features/auth/useAuth";

const TopBar = () => {
  const { user } = useAuth();
  return (
    <header
      className="topbar"
      style={{
        position: "relative",
        height: 160,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 16px",
      }}
    >
      {/* Left: History Nav */}
      <nav className="topbar-nav">
        <NavLink to="/individual">Individual History</NavLink>
        <NavLink to="/teams">Team History</NavLink>
      </nav>

      {/* Center: Logo (absolutely centered) */}
      <img
        className="topbar-logo"
        src="/icons/Logo_PNG.png"
        alt="Logo"
        style={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
          height: 40,
          width: "auto",
          objectFit: "contain",
          pointerEvents: "none",
        }}
      />

      {/* Right: User */}
      <div className="topbar-user">
        <img
          className="topbar-avatar"
          src={user?.profilePictureUrl || "/icons/Logo_PNG.png"}
          alt={user?.username || "User"}
        />
        <div className="topbar-user-meta">
          <div className="topbar-user-name">
            {user?.username || "CatchClicker User"}
          </div>
          <div className="topbar-user-email">{user?.email || ""}</div>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
